import { Component, ViewEncapsulation, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-menu-item',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None,
})
// tslint:disable-next-line:component-class-suffix
export class CfaMenuItem {
    @Input() label: string;
    @Input() textOnly = false;
    @Input() disabled = false;
    @Input() routerLink: string;

    @Output() selected: Subject<void> = new Subject();
}
